<template>
  <div class="vertical-item text-center">
    <div
      class="title p-1 text-white text-uppercase"
      :class="isHighlight ? 'bg-primary' : 'bg-secondary'"
    >
      <span>{{ label }}</span>
    </div>
    <div class="position-relative">
      <small-carousel
        :images="images"
        :show-indicators="false"
        height="160px"
      ></small-carousel>
      <div class="circle-area" v-if="isOffertaSpeciale">
        <p>Offerta Speciale</p>
      </div>
    </div>
    <div class="content-area">
      <div>
        <p>{{ name }}</p>
      </div>
      <h2 class="mb-3">{{ date }}</h2>
      <div class="row" style="height: 50px">
        <div class="col-6">
          <div v-if="nights" class="notti text-left mb-2">
            <p>
              <b>{{ this.nights }}</b> notti<br /><b>{{ this.days }}</b> giorni
            </p>
          </div>
        </div>
        <div v-if="isAltreDate" class="dates-info col-6 mb-2">
          <div class="dates position-relative" v-if="isAltreDate">
            <a
              href="javascript:void(0)"
              class="dates text-uppercase"
              @click="showAltreDate = !showAltreDate"
            >
              altre date disponibili
            </a>
            <div
              v-if="showAltreDate"
              @mouseleave="showAltreDate = false"
              @click="showAltreDate = false"
              class="position-absolute p-1 border rounded bg-white"
              style="
                z-index: 10;
                min-width: 240px;
                max-height: 160px;
                overflow: auto;
                right: 0;
              "
            >
              <button
                v-for="(item, index) in departureFutureDates"
                :key="index"
                @click="onOpenDetailWithDate(item)"
                style="width: 45px"
                class="rounded-0 m-1 px-1 btn btn-outline-primary btn-sm nowrap"
              >
                {{ formatDate(item) }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="isPartenzaGarantita" class="col-6 mb-2">
          <div class="partenza-garantita text-left">
            <p>partenza garantita</p>
          </div>
        </div>
      </div>
    </div>
    <div class="price">
      <div>
        <span>a partire da</span>
      </div>
      <div>
        <h1 class="currency mb-0">{{ price }} &euro;</h1>
      </div>
      <div>
        <small class="w-100 text-center text-uppercase mb-1">{{
          isVoloRequested ? "volo incluso" : "&nbsp;"
        }}</small>
      </div>
      <div class="mb-3">
        <button
          id="scegliTourFunnel"
          class="btn btn-primary px-5"
          @click="onOpenDetail"
        >
          Scegli
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  CONFIG_DATE_FORMAT,
  formatMoney,
  middleDateFormatter,
  smallerDateFormatter,
  toDateFromServer,
} from "../../../../utils/formatter";
import { isSameDate, tourName } from "../../../../utils/helper";
import SmallCarousel from "../SmallCarousel";
import AnalyticEvents from "../../../common/AnalyticEvents";
import ConfigUtils from "../../../utils/ConfigUtils";

export default {
  name: "VerticalItemTour",
  mixins: [AnalyticEvents, ConfigUtils],
  components: { SmallCarousel },
  props: {
    value: Object,
  },
  data() {
    return {
      showAltreDate: false,
    };
  },
  computed: {
    config() {
      return this.value.config;
    },
    detail() {
      return this.value.detailResponse.detail;
    },
    element() {
      return this.value.element;
    },
    escort() {
      return this.detail.escort;
    },
    days() {
      return this.detail.days;
    },
    nights() {
      return this.detail.nights;
    },
    name() {
      return this.config.nome ? this.config.nome : tourName(this.detail.name);
    },
    date() {
      return middleDateFormatter(
        toDateFromServer(this.detail.departureDate.date)
      );
    },
    departuresDatePrice() {
      return this.element.departuresDatePrice;
    },
    departureFutureDates() {
      const dates = this.element.departuresDatePrice.map((item) => {
        return toDateFromServer(item.date.date);
      });
      const partenza = this.getSearch().partenza;
      return partenza == null
        ? dates
        : dates.filter((date) => date.getTime() >= partenza.getTime());
    },
    departureDate() {
      return this.departureFutureDates[0];
    },
    price() {
      const price = this.departuresDatePrice
        .map((item) => item.price.importo)
        .reduce((totale, current) => {
          return Math.min(totale, current);
        });
      return formatMoney(price);
    },
    isOffertaSpeciale() {
      const search = this.getSearch();
      if (search.partenza === null) {
        return this.config && this.config.datesOffertaSpeciale.length > 0;
      }
      return (
        this.config &&
        this.config.datesOffertaSpeciale.some((item) => {
          const date = this.$moment(item).toDate();
          return isSameDate(date, search.partenza);
        })
      );
    },
    label() {
      return this.config.label ? this.config.label : "N/D";
    },
    isHighlight() {
      return this.config.isHighlight ? this.config.isHighlight : false;
    },
    isPartenzaGarantita() {
      const search = this.getSearch();
      if (search.partenza === null) {
        return this.config && this.config.datesPartenzaGarantita.length > 0;
      }
      return (
        this.config &&
        this.config.datesPartenzaGarantita.some((item) => {
          const date = this.$moment(item, CONFIG_DATE_FORMAT).toDate();
          return isSameDate(date, search.partenza);
        })
      );
    },
    isVoloRequested() {
      return this.detail.flightIncluded;
    },
    isAltreDate() {
      return this.departuresDatePrice && this.departuresDatePrice.length > 1;
    },
    images() {
      return this.detail.imagesUrl;
    },
    bgImageStyle() {
      if (!this.images) return "";
      return `background-image: url(${this.images[0]})`;
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTours"]),
    onOpenDetailWithDate(date) {
      this.trackHomeOraPartireAltreDate();
      this.$emit("select", { tour: this.value, date: date });
    },
    onOpenDetail() {
      this.trackHomeOraPartireScegli();
      this.$emit("select", { tour: this.value, date: this.departureDate });
    },
    formatDate(date) {
      return smallerDateFormatter(date);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/tours/VerticalItemTour.vue